/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVulnerabilityComponentDetail {
    getFixupPrototypeFunction() { return AppSecopsSbomVulnerabilityComponentDetail.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVulnerabilityComponentDetail>): AppSecopsSbomVulnerabilityComponentDetail {
        let obj = Object.assign(new AppSecopsSbomVulnerabilityComponentDetail(), model);
        AppSecopsSbomVulnerabilityComponentDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVulnerabilityComponentDetail>): AppSecopsSbomVulnerabilityComponentDetail {
        if (!model) return null;
        return AppSecopsSbomVulnerabilityComponentDetail.newInstance(<AppSecopsSbomVulnerabilityComponentDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVulnerabilityComponentDetail) {
        if (!obj) return;

        models.AppSecopsSbomVulnerabilityComponentDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVulnerabilityComponentDetail): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVulnerabilityComponentDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique ID for the component
     */
    id: string;

    /**
     * Indicates if a fix is available for the component in the vulnerability
     */
    fix_available: boolean;

}
